// extracted by mini-css-extract-plugin
export default {"seedNodes":"SeedNodes_seedNodes__zDDWk","block":"SeedNodes_block__GCn2W"};